import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	giveItATry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	message: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	messageGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismiss: {
		id: 'polaris-lib-onboarding-flows.collections.tour.introduction.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button for the tour spotlight',
	},
	giveItATry: {
		id: 'polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try',
		defaultMessage: 'Give it a try!',
		description: 'The button to take user to the roadmaps view',
	},
	message: {
		id: 'polaris-lib-onboarding-flows.collections.tour.introduction.message',
		defaultMessage:
			'Create a roadmap tailored to the information your stakeholders care about the most by selecting which projects and ideas to include.',
		description: 'Text that notifies the user of the new feature',
	},
	messageGalaxia: {
		id: 'polaris-lib-onboarding-flows.collections.tour.introduction.message-galaxia',
		defaultMessage:
			'Create a roadmap tailored to the information your stakeholders care about the most by selecting which spaces and ideas to include.',
		description: 'Text that notifies the user of the new feature',
	},
});
